import type { FC, PropsWithChildren } from 'react'

import type { ScreenReaderAlertPoliteness } from '@core/accessibility/screenReader/ScreenReaderAlert'

interface ScreenReaderOnlyProps {
  role?: string
  'aria-live'?: ScreenReaderAlertPoliteness
}

/**
 * we just output the styles constant here because we need the styles as a string
 * for alerts rendered by useScreenReaderAlert() which happens outside the scope
 * of Emotion
 */
export const ScreenReaderOnly: FC<PropsWithChildren<ScreenReaderOnlyProps>> = ({
  children,
  ...props
}) => {
  return (
    <span
      style={{
        contain: 'paint',
        opacity: 0,
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        height: 0,
        width: 0,
        fontSize: 0,
        clip: 'rect(0, 0, 0, 0)',
        border: 'none',
        position: 'fixed',
        top: '-200vh',
        left: '-200vw',
      }}
      {...props}
    >
      {children}
    </span>
  )
}
